import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {NotificationPanelComponent} from "./notification-panel.component";

const routes: Routes = [
  {
    path: '',
    component: NotificationPanelComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class NotificationPanelRoutingModule {}
